// File: /pages/About/Awards_And_Recognition.js
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Discuss from 'parts/Discuss';

export default function AwardsAndRecognition() {
  const awards = [
    { year: 2024, title: 'Best Managed Service Provider (Regional) - Tech Awards' }, { year: 2023, title: 'Top Cloud Solutions Provider - Industry Review' }, { year: 2022, title: 'Innovation in Customer Service - Business Awards' },
  ];
  return (
    <>
      <section className="hero py-12">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold text-theme-blue mb-4">Awards & Recognition</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">We’re proud of the recognition our team has earned. Awards reflect our commitment to quality and client success.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-6">
          {awards.map((a) => (
            <div key={a.year} className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold mb-2">{a.year}</h3>
              <p className="text-gray-600">{a.title}</p>
            </div>
          ))}
        </div>
      </section>
      <Discuss />
    </>
  );
}
